import * as dealRecapSelectors from '@makemydeal/dr-dash-store/selectors/dealRecapSelectors';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import { useMediaQuery } from 'react-responsive';
import { Grid } from '@interstate/components/Grid';
import { useDealSummary } from '../../common/DealSummaryProvider';
import DealSummaryItem from '../common/DealSummaryItem';
import { ZERO_DOLLARS } from '../../constants';
import { BackendProfitSchema, DealRecapSectionsLabels } from '../../common/constants/DealRecap';
import { getLabelNodeStyles } from '../utils/transform';
import BackendProfitItem from './BackendProfitItem.interstate';
import { detailedViewGridProps, defaultGridProps, primaryValueNodeStyles, secondaryValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const BackendProfits = () => {
    const { showDetailedView } = useDealSummary();
    const isLargeSize = useMediaQuery({ query: `(min-width: ${BreakPoint.MEDIUM})` });
    const gridProps =
        showDetailedView && isLargeSize ? { ...detailedViewGridProps, gridTemplateColumns: 'repeat(2, 1fr' } : defaultGridProps;
    const backendProfitDetails = useTrackedSelector(dealRecapSelectors.getBackendProfitDetails, {
        component: 'BackendProfits',
        field: 'backendProfitDetails'
    });
    const { backEndProfit, reserve } = backendProfitDetails;
    return (
        <DealSummaryItem
            valueStyles={primaryValueNodeStyles}
            labelStyles={getLabelNodeStyles(showDetailedView, true)}
            label={DealRecapSectionsLabels.BACKEND_PROFIT}
            value={formatDollarsAndCents(backEndProfit, ZERO_DOLLARS)}
        >
            <Grid container sx={gridProps}>
                {BackendProfitSchema.map((item, index) => (
                    <BackendProfitItem
                        key={`${item.label}-${index}`}
                        item={item}
                        index={index}
                        showDetailedView={showDetailedView}
                        valueStyles={secondaryValueStyles}
                        backendProfitDetails={backendProfitDetails}
                        reserve={reserve}
                    />
                ))}
            </Grid>
        </DealSummaryItem>
    );
};

export default BackendProfits;
